import App from "./App.vue";
import Vue from "vue";
import VueHtmlToPaper from "vue-html-to-paper";
import store from "./js/DataManagement/Store";
import "@fortawesome/fontawesome-free/css/all.css";
import vuetify from "vuetify";
import axios from "axios";
import Vuetify from "vuetify/lib";
import $ from "jquery";

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;

// Environment setup
const isProd = process.env.VUE_APP_ENV === "PROD";
const API_HOST = isProd ? "www.urbanresearchmaps.org" : "dev.urbanresearchmaps.org";

Vue.use(VueHtmlToPaper);
Vue.use(vuetify);

function setConfigs(responses) {
  responses.forEach((response) => {
    const { data, config } = response;

    // Named configs (from JSON files)
    if (data.name) {
      Vue.prototype[`$${data.name}`] = data;
      return;
    }

    // Config mapping
    const configMap = {
      mapproposals: "$pgConfig",
      litigation: "$litigationStatuses",
      state_abb_dist_avgs: "$stateData"
    };

    // API configs
    for (const [urlPattern, prototypeName] of Object.entries(configMap)) {
      if (config.url.includes(urlPattern)) {
        Vue.prototype[prototypeName] = urlPattern === "state_abb_dist_avgs"
          ? { states: data }
          : data;
        break;
      }
    }
  });

  // Apply environment-specific API host
  if (process.env.VUE_APP_ENV && Vue.prototype.$mainConfig) {
    Vue.prototype.$mainConfig.api.hosts.api =
      Vue.prototype.$mainConfig.api.hosts[process.env.VUE_APP_ENV];
  }
}

const configs = [
  axios.get("./data/MainConfig.json"),
  axios.get("./data/StyleConfig.json"),
  axios.get("./data/VAPConfig.json"),
  axios.get("./data/VotingPct.json"),
  axios.get("./data/VotingPct2024.json"),
  axios.get(`https://${API_HOST}/US-Redistrict-API/v1/query/state_abb_dist_avgs?columns=*&limit=0`),
  axios.get(`https://${API_HOST}/US-Redistrict-API/v1/query/us_mapproposals?columns=*&filter=active='TRUE'`),
  axios.get(`https://${API_HOST}/US-Redistrict-API/v1/query/litigationstatus?columns=*&limit=0`)
];

Promise.all(configs)
  .then((responses) => {
    $("body > #loading").hide();
    setConfigs(responses);

    new Vue({
      vuetify: new Vuetify({ icons: { iconfont: "fa" } }),
      store,
      mounted() {
        this.$store.commit("setBuildType", process.env.NODE_ENV);
      },
      render: (h) => h(App),
    }).$mount("#app");
  })
  .catch((err) => {
    $("body > #loading").hide();
    $("body > #error, body > #error-message").show();
    $("body > #error-message").html(
      `${err.response.config.url} : ${err}<br/>MESSAGE: ${err.response.data.message || ""}`
    );
    console.error(err.response.data, err.response.status, err.response.headers);
  });
